import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ldc_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("ldc_user", JSON.stringify(data));
      return data;
    } catch (e) {
      console.error("[auth] refreshMe failed", e);
      setUser(null);
      localStorage.removeItem("ldc_user");
      return null;
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("ldc_token");
    if (!token && !document.cookie.includes("session_token")) {
      setLoading(false);
      return;
    }
    refreshMe().finally(() => setLoading(false));
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ldc_token", data.token);
    localStorage.setItem("ldc_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("ldc_token", data.token);
    localStorage.setItem("ldc_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("[auth] logout call failed", e); }
    localStorage.removeItem("ldc_token");
    localStorage.removeItem("ldc_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, register, logout, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
